module.exports = __webpack_public_path__ + "static/media/rocks.de1221a0.png";